(function () {
  'use strict';

  const MODAL_ID = 'th-quality-modal';
  let lastTrigger = null;

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function openModal(key, triggerEl) {
    const modal = getModal();
    if (!modal || typeof modal.showModal !== 'function') return;

    let matched = false;
    modal.querySelectorAll('[data-th-quality-slide]').forEach((slide) => {
      const isMatch = slide.dataset.thQualitySlide === key;
      slide.hidden = !isMatch;
      if (isMatch) matched = true;
    });

    if (!matched) return;
    lastTrigger = triggerEl || document.activeElement;
    if (!modal.open) modal.showModal();
  }

  function closeModal() {
    const modal = getModal();
    if (modal && modal.open) modal.close();
    if (lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-th-quality-trigger]');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      openModal(trigger.dataset.thQualityTrigger, trigger);
      return;
    }

    const closer = event.target.closest('[data-th-quality-close]');
    if (closer) {
      event.preventDefault();
      closeModal();
      return;
    }

    const modal = getModal();
    if (modal && modal.open && event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      const modal = getModal();
      if (modal && modal.open) {
        event.preventDefault();
        closeModal();
      }
    }
  });
})();
